/*
 * @Author: monai
 * @Date: 2021-03-22 14:47:09
 * @LastEditors: muqing
 * @LastEditTime: 2024-11-08 18:13:34
 */
import axios from 'axios';
import type {AxiosRequestConfig} from 'axios';
import {getQueryString, fnColorLog} from '@activity-business/h5-package-frameworkTool';
import HttpClient from "@library/httpClient_activity";
import getToken from '@library/JSBridgeFunction/token';
import getProfile from '@library/JSBridgeFunction/profile';
import {h5Exit} from '@library/hybrid';


type GetLanguage = (includesLangList: string[],useAjaxLang?:boolean) => Promise<string>;
type GetUserCountry = () => Promise<string>;
type IsRegionOpen = (activityId:number|string) => Promise<boolean>;
type GetShareEncrypt = (activityId:number|string,type?:number) => Promise<string>;
type TimeSplit = (time: number, endText?: string, initText?: string, initTime?: number) => string[];

/**
 * 获取页面使用的大区 2024-10废弃（此方法与动态获取域名冲突）
 * @param {*} 参数中的大区
 */
export const getLanguage: GetLanguage =  async (includesLangList,useAjaxLang:boolean=false)=> {
    let LANG: string;
    let ajaxLang:string=''; // 接口中的用户注册地大区

    let paramLang = getQueryString('lang')
    if(!paramLang&&useAjaxLang){
        ajaxLang = await getUserCountryAjax()
    }
    //	优先级: url lang > ajax获取用户注册大区 > 都未获取默认 includesLangList[0]
    LANG = paramLang || ajaxLang || includesLangList[0];
    //  同义转换为大写
    LANG = LANG.toUpperCase();
    //  文案中不存在 LANG 文案，默认显示 includesLangList[0]
    // LANG = includesLangList.includes( LANG ) ? LANG: includesLangList[0];

    return LANG;
}


/**
 * 获取用户注册的大区，根据这个大区，决定文案和页面上的大区差异，如头图
 */
export const getUserCountryAjax: GetUserCountry = async () =>{
    let lang = ''
    await HttpClient.get( '/api/activity/getUserCountry').then(response=>{
        let { data: {data, errorCode} } = response;
        if(errorCode != 0)throw response;
        lang = data.area
        fnColorLog(`> developTool_TS: 已使用接口中用户大区：${lang}`, 'success');
    }).catch(err=>{
        console.error( err );
    });
    return lang
}

/**
 * time: 倒计时，单位 ms
 * endText: 结束时文案，默认 --
 * initText: 初始化时文案，默认 --
 * initTime: 函数内初始化时判断值，默认 -99
 */
export const timeSplit: TimeSplit = (time, endText = '--', initText = '--', initTime = -99)=>{
    //  -99 展示默认初始文案，在时间未加载出来前，保持页面统一，默认 -99
    if (time == initTime) return [initText];
    //  结束文案
    if (time <= 0) return [endText];

    let day = Math.floor(time / 1000 / 60 / 60 / 24);
    let hour = Math.floor(time / 1000 / 60 / 60 % 24);
    let minute = Math.floor(time / 1000 / 60 % 60);
    let seconds = Math.floor(time / 1000 % 60);

    return [
      day.toString(),
      hour > 9 ? hour.toString() : '0' + hour,
      minute > 9 ? minute.toString() : '0' + minute,
      seconds > 9 ? seconds.toString() : '0' + seconds
    ]
}

/**
 * 安卓7及以下为低版本，头图等所有视频文件区别处理，只展示静态图
 */
export const isLowVersion = () => {
    let ua =  navigator.userAgent.toLowerCase();
    // 是否是安卓
    if(/android/i.test(ua)){
        // 匹配安卓大版本
        let match = ua.match(/android\s([0-9]*)/)
        if(match && +match[1]<7){
            return true
        }
    }

    return false
}


/**
 * 获取用户注册的大区是否开放
 */
export const isRegionOpen:IsRegionOpen = async (activityId:number|string) =>{
    if(!activityId){
        fnColorLog(`> 获取用户大区是否开放接口regionOpen未传入活动ID参数`, 'error');
        throw '请传入活动ID！'
        return false
    }
    let isOpen = false;
    await HttpClient.get( `/api/activity/common/regionOpen?activityId=${activityId}`).then(response=>{
        let { data: {data:{status,userArea}, errorCode} } = response;
        if(errorCode != 0) throw response;
        // 0-已开放 1-未开放
        isOpen = status == 0;
        fnColorLog(`> 用户大区：${userArea} ${isOpen?'已':'未'}开放`, 'success');
    }).catch(err=>{
        console.error( err );
    });
    return isOpen
}

/**
 * 用户分享需要获取的加密串
 * @param activityId 
 * @param type  1 站外
 * @returns 
 */
export const fnGetShareEncrypt:GetShareEncrypt = async (activityId:number|string,type:number=1) =>{
    if(!activityId){
        fnColorLog(`> 获取用户加密串接口 getShareEncrypt 未传入活动ID参数`, 'error');
        throw '请传入活动ID！'
        return ''
    }
    
    const {user={}} = await getProfile();
    // 测试环境开发拿不到 jsbridge user 使用链接上的uid
    let uid:string = getQueryString('uid');
    uid = uid || user.uid;
    
    let shareEncrypt:string = '';
    await HttpClient.get(`/api/activity/share/encrypt`,{ params: {activityId, type, uid: uid}}).then(response=>{
        let { data: {data: { status, shareInfo }, errorCode} } = response;
        if(errorCode != 0) throw response;
        
        shareEncrypt = shareInfo
        fnColorLog(`> 已获取用户加密串`, 'success', shareInfo);
    }).catch(err=>{
        console.error( err );
    });
    return shareEncrypt;
}

export class GetHeaderInfo {
	constructor(){}
	async getHeaderInfo(){
		const headerInfo = {};
		//	获取 header 相关信息
		await Promise.all([getToken(), this.getUserInfo()]).then(res => {
			Object.assign(headerInfo, {key: res[0]}, res[1]);
		}).catch(err=> {
			// 重复获取
            console.log(`%c[${new Date().toLocaleTimeString()} - ERROR] - GetHeaderInfo 获取信息错误:`, `color: #F56C6C; font-weight: bolder;`, err);
		});
		return headerInfo;
	}
	async getUserInfo(){
		let did = getQueryString('did'),
		    uid = getQueryString('uid'),
            version = getQueryString('version');
		// 连接上同时存在 uid did 直接返回
		if(did && uid && version) return {uid, did, version};

		let {user={}, device={}} = await getProfile();
		// URL 中获取的 uid did 优先级最高
		uid = uid || user.uid;
		did = did || device.did;
        version = version || device.version;
		return {uid, did, version};
	}
}


export class PrefetchResources {
    private QUERY_MARK: string = CONFIG.prefetchProject.queryMark;
    constructor(config: {completeExit: boolean}) {
        if(document.readyState !== 'complete') {
            window.addEventListener('load', e => this.fnLoadHandle(config));
        }
        else {
            this.fnLoadHandle(config);
        }
    }
    async fnLoadHandle(config) {
        try {
            const {use, config} = window.ACTIVITY_H5_CONFIG?.prefetchResources;
            if(use && config) {
                const country = getQueryString('country') ?? await getProfile().then(res => res?.user?.country).catch(err => undefined);
                if(!country) {
                    // throw new Error(`预加载 - 用户 country 获取失败！`);
                    return;
                }
                // 查询最近配置
                const {projectList, lang} = await HttpClient.get('/api/activity/common/getLatestActivityInfo', {params:{count: config.count, country: country}})
                .then(response=>{
                    const {data: {data, errorCode}} = response;
                    if(errorCode != 0) throw response;
                    const projectList = data.list.reduce((total, info) => {
                        const result = /act_(pk|voiceRoom|center|regular|202)\S+?(?=\/)/.exec(info.url);
                        if(result) {
                            const OSSDirectory = result[0];
                            total.push(OSSDirectory);
                        }
                        return total;
                    }, []);
                    return {projectList, lang: data.lang};
                }).catch(err=>{
                    console.log(err);
                    return {projectList: [], lang: ''};
                    // throw new Error(`预加载 - 项目列表获取失败：${err}`);
                });

                for(const project of projectList) {
                    const isPrefetch = !getQueryString(this.QUERY_MARK) && !location.href.includes(project);
                    if(isPrefetch) {
                        const domain = ENV === 'develop' ? 'https://activity-h5-test.voicemaker.media': location.origin;
                        const url = `${domain}/${project}/index.html?lang=${lang}&${this.QUERY_MARK}=1`;
                        await this.fnIsProjectExist(url);
                    }
                }
            }
        } finally {
            // console.info(`[${new Date().toLocaleString()}] - 预加载完毕！`);
            if(config.completeExit) {
                console.info(`[${new Date().toLocaleString()}] - 关闭预加载 webview！`);
                h5Exit();
            }
        }
    }
    async fnIsProjectExist (url: string){
        const axiosConfig: AxiosRequestConfig = {
            method: 'head',
            url: url,
            headers: {
                'Cache-Control': 'max-age=0',
            }
        };
        await axios(axiosConfig).then(async res => {
            const hasProject = res.headers['content-type']?.includes('html');
            if(hasProject) await this.fnPrefetchProject(url);
        }).catch(err => {
            console.log(`[${new Date().toLocaleString()}] - project: ${url}，加载失败！`, err);
        });
    }
    async fnPrefetchProject(url: string) {
        await new Promise(res => {
            const iframeDom = document.createElement('iframe');
            const iframeStyle: Partial<CSSStyleDeclaration> = {
                width: '0',
                height: '0',
                border: '0',
                visibility: 'hidden'
            };
            Object.assign(iframeDom.style, iframeStyle);
            // url = `${location.origin}/act_regular_TEST_Build_iframe/index.html?lang=${this.country}&prefetchIframe=1`;
            // url = 'https://activity-h5.voicemaker.media/act_202401_Warcraft/index.html?prefetchIframe=1';
            iframeDom.src = url;
            iframeDom.addEventListener('load', e => {
                document.body.removeChild(iframeDom);
                res(undefined);
            });
            document.body.appendChild(iframeDom);
        });
    }
};

export const fnGetShareUrl = (exclude = ['from_page', 'sub_from_page']) => {
    const {search, origin, pathname} = window.location;
    const searchInfo = new URLSearchParams(search);
    exclude.forEach(key => searchInfo.delete(key));
    const searchStr = searchInfo.toString();
    const url = origin + pathname + '?' + searchStr
    return url;
}